import React from "react";
import PropTypes from "prop-types";

import { Container, Underlay } from "./styles";

const Drawer = ({ show = true, onClose, closeLabel = "Cancel", children }) => {
    if (!show) return null;
    return (
        <>
            <Underlay aria-label={closeLabel} onClick={onClose} />
            <Container>{children}</Container>
        </>
    );
};

Drawer.propTypes = {
    show: PropTypes.bool, // whether or not to show the drawer; default is `true`
    onClose: PropTypes.func.isRequired,
    closeLabel: PropTypes.string
};

export default Drawer;
